import { Outlet } from '@remix-run/react';
import { SideOver } from '../../components';
import { elementsColors } from '../../../util';
import { LocalThemeContextProvider } from '../../context';

export function BurnRateElementDetailViewLayoutPage() {
  return (
    <SideOver className="!px-0">
      <LocalThemeContextProvider paletteSeedColor={elementsColors['Br']}>
        <Outlet />
      </LocalThemeContextProvider>
    </SideOver>
  );
}
